
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/fast-track",
      function () {
        return require("private-next-pages/concierge/fast-track.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/fast-track"])
      });
    }
  